import React from "react"
import { Navigate, useLocation } from "react-router-dom"

/** Legacy `/city-portal/*` URLs → equivalent `/admin/*` routes. */
const LEGACY_PATH_MAP = {
  "/city-portal": "/admin/dashboard",
  "/city-portal/inboxes": "/admin/inbox",
  "/city-portal/calls": "/admin/inbox",
  "/city-portal/transfers": "/admin/requests",
}

const CityPortalLegacyRedirect = () => {
  const location = useLocation()
  const pathname = location.pathname.replace(/\/+$/, "") || "/city-portal"
  const target =
    LEGACY_PATH_MAP[pathname] ||
    pathname.replace(/^\/city-portal/, "/admin")

  return (
    <Navigate
      to={`${target}${location.search}${location.hash}`}
      replace
    />
  )
}

export default CityPortalLegacyRedirect
